// L'ID du tag AB Tasty arrive par les technicalVars du back-office (comme GTM_ID / ONE_TRUST_SCRIPT).
// brandMiddleware lit brand.json sur test/preprod même en localhost et en e2e (cf. middlewares.js,
// bloc `req.hostname.includes("localhost") || environment.includes("e2e")` → fallbackUrl), donc la
// simple présence de l'ID ne suffit pas comme garde : on exclut explicitement les environnements e2e,
// où le tag muterait le DOM en pleine exécution des specs Cypress.
// `includes("e2e")` couvre `e2e` et `e2e-remote`.
export const isAbTastyTagEnabled = ({ tagId, environment = "" }) => {
	return Boolean(tagId) && !environment.includes("e2e");
};
